module.exports = __webpack_public_path__ + "img/DelHint.65bef3a1.png";